var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagementRolesLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 53,
    viewBox: "0 0 68 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    d: "M65.583 11.333c0 1.565-1.268 2.834-2.833 2.834H3.25c-1.565 0-2.833-1.269-2.833-2.834v-8.5C.417 1.27 1.685 0 3.25 0h59.5c1.565 0 2.833 1.269 2.833 2.833v8.5z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.75 19.833v28.334c0 1.564-1.269 2.833-2.833 2.833H6.083C4.52 51 3.25 49.731 3.25 48.167V19.833",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.917 26.917c0 2.347-1.903 4.25-4.25 4.25H27.333c-2.347 0-4.25-1.903-4.25-4.25 0-2.348 1.903-4.25 4.25-4.25h11.334c2.347 0 4.25 1.902 4.25 4.25h0z",
    transform: "translate(1 1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementRolesLarge);
export default __webpack_public_path__ + "static/media/management-roles-large.20aedfc1916c6c99b2222bd58e3dfc0f.svg";
export { ForwardRef as ReactComponent };